function injectStyle(id, style) {
    try {
        const script = document.getElementById(id);
        script?.remove();
        const elem = document.createElement("div");
        elem.id = id;
        elem.style.display = "none";
        elem.innerHTML = `&shy;<style>${style}</style>`;
        document.body.appendChild(elem);
        return elem;
    } catch  {
        return false;
    }
}
function resizeOpposite(containerId, oppositeId, width) {
    return injectStyle(`${containerId}-styleOpposite`, `#${oppositeId}{ width: -webkit-calc(100% - ${width}px);width: -moz-calc(100% - ${width}px);width: calc(100% - ${width}px); }`);
}
export { injectStyle, resizeOpposite };
